import { subscriptionRepository } from '../repositories/subscription-repository';

async function getSubscriptions() {
    return subscriptionRepository.getAll();
}

export {
    getSubscriptions
};
